import React, { useEffect, useState } from 'react';
import { Flame } from 'lucide-react';
export function CountdownBar() {
  const [timeLeft, setTimeLeft] = useState(24 * 60 * 60);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const h = Math.floor(timeLeft / 3600);
  const m = Math.floor(timeLeft % 3600 / 60);
  const s = timeLeft % 60;
  const pad = (n: number) => String(n).padStart(2, '0');
  const scrollToOferta = () => {
    document.getElementById('oferta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <button onClick={scrollToOferta} className="fixed top-0 left-0 right-0 z-50 bg-celeste text-navy py-2 px-4 flex items-center justify-center gap-2 text-sm font-bold hover:bg-celeste/90 transition-colors shadow-md" aria-label="La oferta termina pronto, ver oferta" data-id="element-82">
      <Flame className="w-4 h-4 flex-shrink-0" data-id="element-83" />
      <span className="hidden sm:inline uppercase tracking-wide font-display" data-id="element-84">
        OFERTA DE LANZAMIENTO TERMINA EN:
      </span>
      <span className="sm:hidden uppercase tracking-wide font-display text-xs" data-id="element-85">
        OFERTA TERMINA EN:
      </span>
      <span className="font-display font-black tabular-nums tracking-wider" data-id="element-86">
        {pad(h)}:{pad(m)}:{pad(s)}
      </span>
    </button>;
}